module.exports = __webpack_public_path__ + "static/media/down-arow-white.edcdb74f.svg";